export const apiUrl = '/api/app';

export const TABLET_SCREEN_WIDTH_THRESHOLD = 768;